import useTetrazolio from '../../hooks/useTetrazolio';
import useCanteiroAreia from '../../hooks/useCanteiroAreia';
import FiltroSementes from './FiltroSementes/FiltroSementes';
import ListaSementesTabs from './ListaSementesTabs/ListaSementesTabs';
import Header from '../../../../../components/Header/Header';
import PageTitle from '../../../../../components/PageTitle/PageTitle';

export default function ListaSementesPage() {
  const tetrazolioData = useTetrazolio();
  const canteiroAreiaData = useCanteiroAreia();

  return (
    <main className="lista-sementes-page">
      <Header>
        <PageTitle title="Laboratório de Sementes" />
      </Header>
      <FiltroSementes
        tetrazolioData={tetrazolioData}
        canteiroAreiaData={canteiroAreiaData}
      />
      <ListaSementesTabs
        tetrazolioData={tetrazolioData}
        canteiroAreiaData={canteiroAreiaData}
      />
    </main>
  );
}
